export const BITF_PARSER_HEADER_NAME = 'BitfParserType';
